import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box, Stack } from '@chakra-ui/react';

import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import SunshineCard from 'components/_core/SunshineCard';
import SunshineTag from 'components/_core/SunshineTag';
import { logEvent } from 'features/Analytics/analytics';
import * as workRoutes from 'features/Upgrade/routes';

import locales from './locales';

interface UpsellCardProps {
  hasItems?: boolean;
}

const UpsellCard: FC<UpsellCardProps> = ({ hasItems = false }) => {
  const onChangePlanClick = () => {
    logEvent({
      name: 'Catalog Items Upsell Change Plan Clicked',
      properties: { source: 'web-app' },
      usePrefix: false,
    });
  };

  return (
    <SunshineCard>
      <SunshineCard.Content>
        <Stack spacing="space-16">
          <Box>
            <SunshineTag colorScheme="grey" icon="star" size="sm">
              {locales.badge}
            </SunshineTag>
          </Box>

          <Heading>
            {hasItems ? locales.retrieveTitle : locales.saveTitle}
          </Heading>

          <SunshineCard.Text>{locales.description}</SunshineCard.Text>
        </Stack>
      </SunshineCard.Content>

      <Button
        as={Link}
        icon="arrow-right"
        marginTop="space-32"
        onClick={onChangePlanClick}
        to={workRoutes.choice}
      >
        {locales.button}
      </Button>
    </SunshineCard>
  );
};

export default UpsellCard;
